import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { CaseType } from "@teamprevent/common/model";

import ohCaseApi from "../crud/ohCase/ohCaseApi";

import * as actions from "./actionTypes";

export type DashboardAction = ({ type: typeof actions.LOAD_OH_CASE_COUNT_SUCCESS; payload: number }
    | { type: typeof actions.LOAD_WORK_ADJUSTMENT_COUNT_SUCCESS; payload: number });

export const loadOhCaseCountSuccess = (payload: number): DashboardAction => ({
    payload,
    type: actions.LOAD_OH_CASE_COUNT_SUCCESS
});

export const loadWorkAdjustmentsCountSuccess = (payload: number): DashboardAction => ({
    payload,
    type: actions.LOAD_WORK_ADJUSTMENT_COUNT_SUCCESS
});

export function loadOhCaseCount() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_OH_CASE_COUNT, ohCaseApi.getOpenCount());
        dispatch(loadOhCaseCountSuccess(result));
    };
}

export function loadWorkAdjustmentCount() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_WORK_ADJUSTMENT_COUNT, ohCaseApi.getOpenCount(CaseType.WORK_ADJUSTMENT));
        dispatch(loadWorkAdjustmentsCountSuccess(result));
    };
}
